import team1 from '../resources/bull2.png';
import team2 from '../resources/bull3.png';
import team3 from '../resources/bull4.png';
import team4 from '../resources/bull5.png';


import team5 from '../resources/bul1.png';
import team6 from '../resources/bul2.png';
import team7 from '../resources/bul3.png';
import team8 from '../resources/bul3.png';


import dog1 from '../resources/pit3.png';
import pit2 from '../resources/pit1.png';
import pit3 from '../resources/pit2.png';
import pit4 from '../resources/pit4.png';




type MediaItem = 
  | { type: 'image'; url: string } 
  | { type: 'video'; url: string; thumbnail?: string };

interface Pet {
  id: number;
  name: string;
  breed: string;
  color: string;
  age: string;
  size: string;
  gender: string;
  location: string;
  images: MediaItem[];
  description: string;
  adoptionFee: number;
  vaccinated: boolean;
  neutered: boolean;
  temperament: string[];
  healthNotes: string;
  story: string;
  goodWith: string[];
}

const petData: Pet[] = [
  {
    id: 1,
    name: "Axel",
    breed: "French Bulldog",
    color: "Blue Fawn",
    age: "13 weeks",
    size: "Medium",
    gender: "Male",
    location: "Florida but can be delivered to any part of the country",
    images: [
      { type: 'image', url: team1 },
      { type: 'image', url: team2 },
      { type: 'image', url: team3 },
      { type: 'image', url: team4 }
        // { 
      //   type: 'video', 
      //   url: "/videos/bull.mp4",
      //   thumbnail: "https://example.com/thumbnails/max_playing.jpg" 
      // },
    ],
    description: "Friendly and energetic, Axel loves playing fetch and swimming. Great with children and other pets.",
    adoptionFee: 1200,
    vaccinated: true,
    neutered: true,
    temperament: ["Playful", "Energetic", "Friendly"],
    healthNotes: "Fully vaccinated, neutered, and microchipped. Regular checkups.",
    story: "Found as a stray and brought to our shelter. Ready for a loving home.",
    goodWith: ["Children", "Other Dogs", "Cats"]
  },
  {
    id: 2,
    name: "Daisy",
    breed: "French Bulldog",
    color: "Blue & Tan",
    age: "12weeks",
    size: "small",
    gender: "Female",
    location: "Miami",
    images: [
    { type: 'image', url: team5 },
      { type: 'image', url: team6 },
      { type: 'image', url: team7 },
      { type: 'image', url: team8 }
    ],
    description: "Adorable Frenchie with a playful personality. Loves cuddles and short walks.",
    adoptionFee: 3200,
    vaccinated: true,
    neutered: true,
    temperament: ["Affectionate", "Playful", "Adaptable"],
    healthNotes: "Vaccinated, spayed, and healthy. Requires climate-controlled environment.",
    story: "....",
    goodWith: ["Children", "Adults"]
  },
  {
    id: 3,
    name: "Rocky",
    breed: "French Bulldog",
    color: "Gray brown",
    age: "15weeks",
    size: "large",
    gender: "Male",
    location: "Denver",
    images: [
        { type: 'image', url: pit4 },
      { type: 'image', url: pit2 },
      { type: 'image', url: pit3 },
      { type: 'image', url: dog1 }
        // { 
    ],
    description: "Beautiful Frenchie with high energy. Needs active owners and space to run.",
    adoptionFee: 1200,
    vaccinated: true,
    neutered: true,
    temperament: ["Energetic", "Loyal", "Independent"],
    healthNotes: "Vaccinated and neutered. Needs regular exercise.",
    story: "Surrendered due to owner's health issues. Ready for adventure.",
    goodWith: ["Other Dogs", "Adults"]
  },
  {
    id: 4,
    name: "Lola",
    breed: "Cavalier King Charles Spaniel",
    color: "Ruby",
    age: "1.5 years",
    size: "small",
    gender: "Female",
    location: "San Francisco",
    images: [
      { type: 'image', url: "https://source.unsplash.com/800x600/?cavalier,dog" },
      { 
        type: 'video', 
        url: "https://example.com/videos/lola_playing.mp4",
        thumbnail: "https://example.com/thumbnails/lola_playing.jpg"
      },
      { type: 'image', url: "https://source.unsplash.com/800x600/?cavalier-king-charles,dog" }
    ],
    description: "Gentle and affectionate companion. Perfect lap dog with sweet temperament.",
    adoptionFee: 2900,
    vaccinated: true,
    neutered: true,
    temperament: ["Gentle", "Affectionate", "Patient"],
    healthNotes: "Up-to-date vaccinations and spayed. Regular heart checkups recommended.",
    story: "Came from a reputable breeder. Owner passed away unexpectedly.",
    goodWith: ["Children", "Other Dogs", "Cats"]
  },
  {
    id: 5,
    name: "Duke",
    breed: "German Shepherd",
    color: "Black & Tan",
    age: "2 years",
    size: "large",
    gender: "Male",
    location: "Chicago",
    images: [
      { type: 'image', url: "https://source.unsplash.com/800x600/?german-shepherd,dog" },
      { 
        type: 'video', 
        url: "https://example.com/videos/duke_training.mp4",
        thumbnail: "https://example.com/thumbnails/duke_training.jpg"
      },
      { type: 'image', url: "https://source.unsplash.com/800x600/?shepherd,dog" }
    ],
    description: "Highly intelligent and protective. Excellent guard dog with proper training.",
    adoptionFee: 1500,
    vaccinated: true,
    neutered: true,
    temperament: ["Loyal", "Confident", "Courageous"],
    healthNotes: "Fully vaccinated and neutered. Hip certification available.",
    story: "Police K9 dropout - too friendly for police work!",
    goodWith: ["Adults", "Teens"]
  },
  {
    id: 6,
    name: "Molly",
    breed: "Beagle",
    color: "Tri-color",
    age: "6 months",
    size: "medium",
    gender: "Female",
    location: "Boston",
    images: [
      { type: 'image', url: "https://source.unsplash.com/800x600/?beagle,dog" },
      { 
        type: 'video', 
        url: "https://example.com/videos/molly_playing.mp4",
        thumbnail: "https://example.com/thumbnails/molly_playing.jpg"
      },
      { type: 'image', url: "https://source.unsplash.com/800x600/?beagle-puppy,dog" }
    ],
    description: "Curious and merry beagle with great nose. Loves following scents and playing.",
    adoptionFee: 1300,
    vaccinated: true,
    neutered: false,
    temperament: ["Friendly", "Curious", "Merry"],
    healthNotes: "Vaccinations up-to-date. Scheduled for spaying next month.",
    story: "Rescued from puppy mill. Learning to trust humans.",
    goodWith: ["Children", "Other Dogs"]
  },
  {
    id: 7,
    name: "Zeus",
    breed: "Great Dane",
    color: "Harlequin",
    age: "3 years",
    size: "extra-large",
    gender: "Male",
    location: "Dallas",
    images: [
      { type: 'image', url: "https://source.unsplash.com/800x600/?great-dane,dog" },
      { 
        type: 'video', 
        url: "https://example.com/videos/zeus_walking.mp4",
        thumbnail: "https://example.com/thumbnails/zeus_walking.jpg"
      },
      { type: 'image', url: "https://source.unsplash.com/800x600/?big-dog" }
    ],
    description: "Gentle giant with calm demeanor. Loves lounging and gentle walks.",
    adoptionFee: 1100,
    vaccinated: true,
    neutered: true,
    temperament: ["Friendly", "Patient", "Gentle"],
    healthNotes: "Vaccinated and neutered. Requires large breed food.",
    story: "Owner moved to small apartment with no space.",
    goodWith: ["Children", "Other Dogs", "Cats"]
  },
  {
    id: 8,
    name: "Sophie",
    breed: "Poodle",
    color: "Apricot",
    age: "1 year",
    size: "medium",
    gender: "Female",
    location: "Seattle",
    images: [
      { type: 'image', url: "https://source.unsplash.com/800x600/?poodle,dog" },
      { 
        type: 'video', 
        url: "https://example.com/videos/sophie_grooming.mp4",
        thumbnail: "https://example.com/thumbnails/sophie_grooming.jpg"
      },
      { type: 'image', url: "https://source.unsplash.com/800x600/?poodle-groomed,dog" }
    ],
    description: "Highly intelligent and hypoallergenic. Excellent family companion.",
    adoptionFee: 2500,
    vaccinated: true,
    neutered: true,
    temperament: ["Intelligent", "Active", "Proud"],
    healthNotes: "Fully vaccinated and spayed. No known health issues.",
    story: "Show dog retired early due to minor conformation issue.",
    goodWith: ["Children", "Other Dogs"]
  },
  {
    id: 9,
    name: "Cooper",
    breed: "Australian Shepherd",
    color: "Blue Merle",
    age: "2 years",
    size: "medium",
    gender: "Male",
    location: "Portland",
    images: [
      { type: 'image', url: "https://source.unsplash.com/800x600/?australian-shepherd,dog" },
      { 
        type: 'video', 
        url: "https://example.com/videos/cooper_agility.mp4",
        thumbnail: "https://example.com/thumbnails/cooper_agility.jpg"
      },
      { type: 'image', url: "https://source.unsplash.com/800x600/?herding-dog" }
    ],
    description: "Energetic herding dog needing active lifestyle. Great at agility.",
    adoptionFee: 1600,
    vaccinated: true,
    neutered: true,
    temperament: ["Smart", "Work-oriented", "Energetic"],
    healthNotes: "Vaccinated and neutered. Requires mental stimulation.",
    story: "Farmer surrendered after downsizing livestock.",
    goodWith: ["Other Dogs", "Adults"]
  },
  {
    id: 10,
    name: "Zoe",
    breed: "Dachshund",
    color: "Red",
    age: "9 months",
    size: "small",
    gender: "Female",
    location: "Atlanta",
    images: [
      { type: 'image', url: "https://source.unsplash.com/800x600/?dachshund,dog" },
      { 
        type: 'video', 
        url: "https://example.com/videos/zoe_playing.mp4",
        thumbnail: "https://example.com/thumbnails/zoe_playing.jpg"
      },
      { type: 'image', url: "https://source.unsplash.com/800x600/?sausage-dog" }
    ],
    description: "Bold little dog with big personality. Loves burrowing and playing.",
    adoptionFee: 1800,
    vaccinated: true,
    neutered: true,
    temperament: ["Curious", "Spunky", "Lively"],
    healthNotes: "Vaccinated and spayed. Use ramps to prevent back issues.",
    story: "Rescue from backyard breeder situation.",
    goodWith: ["Adults", "Teens"]
  },
  {
    id: 11,
    name: "Bear",
    breed: "Bernese Mountain Dog",
    color: "Tri-color",
    age: "2.5 years",
    size: "large",
    gender: "Male",
    location: "Denver",
    images: [
      { type: 'image', url: "https://source.unsplash.com/800x600/?bernese,dog" },
      { 
        type: 'video', 
        url: "https://example.com/videos/bear_mountains.mp4",
        thumbnail: "https://example.com/thumbnails/bear_mountains.jpg"
      },
      { type: 'image', url: "https://source.unsplash.com/800x600/?berner,dog" }
    ],
    description: "Gentle giant with beautiful tri-color coat. Great with families.",
    adoptionFee: 2800,
    vaccinated: true,
    neutered: true,
    temperament: ["Good-natured", "Calm", "Strong"],
    healthNotes: "Vaccinated and neutered. Regular grooming needed.",
    story: "Family moved overseas and couldn't take him.",
    goodWith: ["Children", "Other Dogs"]
  },
  {
    id: 12,
    name: "Ruby",
    breed: "Corgi",
    color: "Sable",
    age: "1 year",
    size: "small",
    gender: "Female",
    location: "Seattle",
    images: [
      { type: 'image', url: "https://source.unsplash.com/800x600/?corgi,dog" },
      { 
        type: 'video', 
        url: "https://example.com/videos/ruby_herding.mp4",
        thumbnail: "https://example.com/thumbnails/ruby_herding.jpg"
      },
      { type: 'image', url: "https://source.unsplash.com/800x600/?corgi-puppy" }
    ],
    description: "Smart and affectionate with iconic short legs. Loves herding games.",
    adoptionFee: 3200,
    vaccinated: true,
    neutered: true,
    temperament: ["Alert", "Intelligent", "Friendly"],
    healthNotes: "Vaccinated and spayed. Weight management important.",
    story: "From reputable breeder, family had allergy issues.",
    goodWith: ["Children", "Other Dogs"]
  },
  {
    id: 13,
    name: "Tucker",
    breed: "Boxer",
    color: "Fawn",
    age: "3 years",
    size: "large",
    gender: "Male",
    location: "Chicago",
    images: [
      { type: 'image', url: "https://source.unsplash.com/800x600/?boxer,dog" },
      { 
        type: 'video', 
        url: "https://example.com/videos/tucker_running.mp4",
        thumbnail: "https://example.com/thumbnails/tucker_running.jpg"
      },
      { type: 'image', url: "https://source.unsplash.com/800x600/?boxer-dog" }
    ],
    description: "Playful and energetic with goofy personality. Great running partner.",
    adoptionFee: 1250,
    vaccinated: true,
    neutered: true,
    temperament: ["Playful", "Devoted", "Energetic"],
    healthNotes: "Vaccinated and neutered. Regular vet checks.",
    story: "Surrendered when owner deployed overseas.",
    goodWith: ["Children", "Other Dogs"]
  },
  {
    id: 14,
    name: "Lily",
    breed: "Shih Tzu",
    color: "Gold & White",
    age: "4 months",
    size: "small",
    gender: "Female",
    location: "Miami",
    images: [
      { type: 'image', url: "https://source.unsplash.com/800x600/?shih-tzu,dog" },
      { 
        type: 'video', 
        url: "https://example.com/videos/lily_pampered.mp4",
        thumbnail: "https://example.com/thumbnails/lily_pampered.jpg"
      },
      { type: 'image', url: "https://source.unsplash.com/800x600/?tzu,dog" }
    ],
    description: "Sweet lap dog with beautiful coat. Enjoys being pampered.",
    adoptionFee: 2400,
    vaccinated: true,
    neutered: false,
    temperament: ["Affectionate", "Playful", "Outgoing"],
    healthNotes: "First vaccinations complete. Needs grooming every 6 weeks.",
    story: "Accidental litter from responsible breeder.",
    goodWith: ["Children", "Other Dogs", "Cats"]
  },
  {
    id: 15,
    name: "Rex",
    breed: "Rottweiler",
    color: "Black & Tan",
    age: "2 years",
    size: "large",
    gender: "Male",
    location: "Philadelphia",
    images: [
      { type: 'image', url: "https://source.unsplash.com/800x600/?rottweiler,dog" },
      { 
        type: 'video', 
        url: "https://example.com/videos/rex_guardian.mp4",
        thumbnail: "https://example.com/thumbnails/rex_guardian.jpg"
      },
      { type: 'image', url: "https://source.unsplash.com/800x600/?rottie" }
    ],
    description: "Confident guardian with strong loyalty. Needs experienced owner.",
    adoptionFee: 1400,
    vaccinated: true,
    neutered: true,
    temperament: ["Courageous", "Loyal", "Confident"],
    healthNotes: "Vaccinated and neutered. Excellent health.",
    story: "Rescue from neglect situation - rehabilitated well.",
    goodWith: ["Adults", "Teens"]
  },
  {
    id: 16,
    name: "Chloe",
    breed: "Pomeranian",
    color: "Orange",
    age: "5 months",
    size: "small",
    gender: "Female",
    location: "New York",
    images: [
      { type: 'image', url: "https://source.unsplash.com/800x600/?pomeranian,dog" },
      { 
        type: 'video', 
        url: "https://example.com/videos/chloe_attention.mp4",
        thumbnail: "https://example.com/thumbnails/chloe_attention.jpg"
      },
      { type: 'image', url: "https://source.unsplash.com/800x600/?pomeranian-puppy" }
    ],
    description: "Fluffy ball of energy with big personality. Loves being center of attention.",
    adoptionFee: 3100,
    vaccinated: true,
    neutered: false,
    temperament: ["Lively", "Bold", "Inquisitive"],
    healthNotes: "Vaccinations in progress. Teething phase.",
    story: "Breeder release - slightly smaller than show standard.",
    goodWith: ["Adults", "Teens"]
  },
  {
    id: 17,
    name: "Oscar",
    breed: "Bulldog",
    color: "Brindle & White",
    age: "1.5 years",
    size: "medium",
    gender: "Male",
    location: "Los Angeles",
    images: [
      { type: 'image', url: "https://source.unsplash.com/800x600/?bulldog,dog" },
      { 
        type: 'video', 
        url: "https://example.com/videos/oscar_chilling.mp4",
        thumbnail: "https://example.com/thumbnails/oscar_chilling.jpg"
      },
      { type: 'image', url: "https://source.unsplash.com/800x600/?bulldog-puppy" }
    ],
    description: "Chill companion with adorable wrinkles. Enjoys moderate exercise.",
    adoptionFee: 3300,
    vaccinated: true,
    neutered: true,
    temperament: ["Calm", "Friendly", "Courageous"],
    healthNotes: "Vaccinated and neutered. Requires wrinkle cleaning.",
    story: "Retired from breeding program - ready for family life.",
    goodWith: ["Children", "Other Dogs"]
  },
  {
    id: 18,
    name: "Mia",
    breed: "Border Collie",
    color: "Black & White",
    age: "2 years",
    size: "medium",
    gender: "Female",
    location: "Portland",
    images: [
      { type: 'image', url: "https://source.unsplash.com/800x600/?border-collie,dog" },
      { 
        type: 'video', 
        url: "https://example.com/videos/mia_agility.mp4",
        thumbnail: "https://example.com/thumbnails/mia_agility.jpg"
      },
      { type: 'image', url: "https://source.unsplash.com/800x600/?herding-dog" }
    ],
    description: "Brilliant herding dog needing mental challenges. Excellent at agility.",
    adoptionFee: 1500,
    vaccinated: true,
    neutered: true,
    temperament: ["Intelligent", "Energetic", "Responsive"],
    healthNotes: "Vaccinated and spayed. Needs daily mental stimulation.",
    story: "Working farm dog needing less intensive home.",
    goodWith: ["Adults", "Teens"]
  },
  {
    id: 19,
    name: "Teddy",
    breed: "Goldendoodle",
    color: "Cream",
    age: "7 months",
    size: "medium",
    gender: "Male",
    location: "Boston",
    images: [
      { type: 'image', url: "https://source.unsplash.com/800x600/?goldendoodle,dog" },
      { 
        type: 'video', 
        url: "https://example.com/videos/teddy_playing.mp4",
        thumbnail: "https://example.com/thumbnails/teddy_playing.jpg"
      },
      { type: 'image', url: "https://source.unsplash.com/800x600/?poodle-mix" }
    ],
    description: "Hypoallergenic mix with wavy coat. Great for families with allergies.",
    adoptionFee: 3400,
    vaccinated: true,
    neutered: false,
    temperament: ["Friendly", "Intelligent", "Trainable"],
    healthNotes: "Vaccinations up-to-date. Neutering scheduled.",
    story: "Family couldn't handle puppy energy in apartment.",
    goodWith: ["Children", "Other Dogs"]
  },
  {
    id: 20,
    name: "Rosie",
    breed: "Australian Cattle Dog",
    color: "Blue Speckled",
    age: "3 years",
    size: "medium",
    gender: "Female",
    location: "Austin",
    images: [
      { type: 'image', url: "https://source.unsplash.com/800x600/?cattle-dog,dog" },
      { 
        type: 'video', 
        url: "https://example.com/videos/rosie_herding.mp4",
        thumbnail: "https://example.com/thumbnails/rosie_herding.jpg"
      },
      { type: 'image', url: "https://source.unsplash.com/800x600/?australian-cattle-dog" }
    ],
    description: "Hardworking herder needing active lifestyle. Very loyal companion.",
    adoptionFee: 1200,
    vaccinated: true,
    neutered: true,
    temperament: ["Alert", "Curious", "Loyal"],
    healthNotes: "Vaccinated and spayed. High energy level.",
    story: "Ranch dog needing retirement from work duties.",
    goodWith: ["Adults", "Teens"]
  },
  {
    id: 21,
    name: "Jack",
    breed: "Jack Russell Terrier",
    color: "White & Tan",
    age: "1 year",
    size: "small",
    gender: "Male",
    location: "San Diego",
    images: [
      { type: 'image', url: "https://source.unsplash.com/800x600/?jack-russell,dog" },
      { 
        type: 'video', 
        url: "https://example.com/videos/jack_energetic.mp4",
        thumbnail: "https://example.com/thumbnails/jack_energetic.jpg"
      },
      { type: 'image', url: "https://source.unsplash.com/800x600/?jrt" }
    ],
    description: "Energetic little dog with big personality. Needs active owners.",
    adoptionFee: 1600,
    vaccinated: true,
    neutered: true,
    temperament: ["Energetic", "Intelligent", "Fearless"],
    healthNotes: "Vaccinated and neutered. Requires secure yard.",
    story: "Rescue from high-kill shelter in California.",
    goodWith: ["Adults", "Teens"]
  },
  {
    id: 22,
    name: "Stella",
    breed: "Weimaraner",
    color: "Silver Gray",
    age: "2 years",
    size: "large",
    gender: "Female",
    location: "Portland",
    images: [
      { type: 'image', url: "https://source.unsplash.com/800x600/?weimaraner,dog" },
      { 
        type: 'video', 
        url: "https://example.com/videos/stella_running.mp4",
        thumbnail: "https://example.com/thumbnails/stella_running.jpg"
      },
      { type: 'image', url: "https://source.unsplash.com/800x600/?hunting-dog" }
    ],
    description: "Elegant silver-grey hunter needing space to run. Very affectionate.",
    adoptionFee: 1700,
    vaccinated: true,
    neutered: true,
    temperament: ["Powerful", "Stubborn", "Affectionate"],
    healthNotes: "Vaccinated and spayed. Needs vigorous exercise.",
    story: "Show dog retired due to minor conformation issue.",
    goodWith: ["Adults", "Other Dogs"]
  },
  {
    id: 23,
    name: "Rusty",
    breed: "Irish Setter",
    color: "Mahogany",
    age: "1.5 years",
    size: "large",
    gender: "Male",
    location: "Boston",
    images: [
      { type: 'image', url: "https://source.unsplash.com/800x600/?irish-setter,dog" },
      { 
        type: 'video', 
        url: "https://example.com/videos/rusty_family.mp4",
        thumbnail: "https://example.com/thumbnails/rusty_family.jpg"
      },
      { type: 'image', url: "https://source.unsplash.com/800x600/?red-dog" }
    ],
    description: "Beautiful red coat with friendly personality. Great family companion.",
    adoptionFee: 1900,
    vaccinated: true,
    neutered: true,
    temperament: ["Outgoing", "Sweet-natured", "Active"],
    healthNotes: "Vaccinated and neutered. Regular grooming needed.",
    story: "Family had unexpected financial hardship.",
    goodWith: ["Children", "Other Dogs"]
  },
  {
    id: 24,
    name: "Abby",
    breed: "Bichon Frise",
    color: "White",
    age: "3 months",
    size: "small",
    gender: "Female",
    location: "Miami",
    images: [
      { type: 'image', url: "https://source.unsplash.com/800x600/?bichon-frise,dog" },
      { 
        type: 'video', 
        url: "https://example.com/videos/abby_cheerful.mp4",
        thumbnail: "https://example.com/thumbnails/abby_cheerful.jpg"
      },
      { type: 'image', url: "https://source.unsplash.com/800x600/?white-dog" }
    ],
    description: "Fluffy white companion with cheerful disposition. Hypoallergenic coat.",
    adoptionFee: 3500,
    vaccinated: false,
    neutered: false,
    temperament: ["Playful", "Curious", "Peppy"],
    healthNotes: "First vet check complete. Needs vaccination series.",
    story: "From reputable breeder - family adoption.",
    goodWith: ["Children", "Other Dogs", "Cats"]
  },
  {
    id: 25,
    name: "Bruno",
    breed: "Mastiff",
    color: "Fawn",
    age: "3 years",
    size: "extra-large",
    gender: "Male",
    location: "Dallas",
    images: [
      { type: 'image', url: "https://source.unsplash.com/800x600/?mastiff,dog" },
      { 
        type: 'video', 
        url: "https://example.com/videos/bruno_protector.mp4",
        thumbnail: "https://example.com/thumbnails/bruno_protector.jpg"
      },
      { type: 'image', url: "https://source.unsplash.com/800x600/?large-dog" }
    ],
    description: "Massive but gentle protector. Calm demeanor in home environment.",
    adoptionFee: 2100,
    vaccinated: true,
    neutered: true,
    temperament: ["Courageous", "Good-natured", "Protective"],
    healthNotes: "Vaccinated and neutered. Joint supplements recommended.",
    story: "Previous owner passed away - looking for new home.",
    goodWith: ["Adults", "Teens"]
  },
  {
    id: 26,
    name: "Piper",
    breed: "Shetland Sheepdog",
    color: "Sable & White",
    age: "10 months",
    size: "small",
    gender: "Female",
    location: "Chicago",
    images: [
      { type: 'image', url: "https://source.unsplash.com/800x600/?sheltie,dog" },
      { 
        type: 'video', 
        url: "https://example.com/videos/piper_training.mp4",
        thumbnail: "https://example.com/thumbnails/piper_training.jpg"
      },
      { type: 'image', url: "https://source.unsplash.com/800x600/?collie-dog" }
    ],
    description: "Miniature collie look-alike with intelligence. Great for obedience training.",
    adoptionFee: 2300,
    vaccinated: true,
    neutered: true,
    temperament: ["Intelligent", "Lively", "Trainable"],
    healthNotes: "Vaccinated and spayed. Regular brushing needed.",
    story: "Surrendered when family had new baby with allergies.",
    goodWith: ["Children", "Other Dogs"]
  },
  {
    id: 27,
    name: "Gus",
    breed: "Boston Terrier",
    color: "Black & White",
    age: "1 year",
    size: "small",
    gender: "Male",
    location: "New York",
    images: [
      { type: 'image', url: "https://source.unsplash.com/800x600/?boston-terrier,dog" },
      { 
        type: 'video', 
        url: "https://example.com/videos/gus_city.mp4",
        thumbnail: "https://example.com/thumbnails/gus_city.jpg"
      },
      { type: 'image', url: "https://source.unsplash.com/800x600/?tuxedo-dog" }
    ],
    description: "Tuxedo-marked gentleman with charming personality. Adapts well to city life.",
    adoptionFee: 2700,
    vaccinated: true,
    neutered: true,
    temperament: ["Friendly", "Bright", "Amusing"],
    healthNotes: "Vaccinated and neutered. Avoid extreme temperatures.",
    story: "Rescue from overcrowded shelter in Midwest.",
    goodWith: ["Children", "Other Dogs", "Cats"]
  },
  {
    id: 28,
    name: "Lulu",
    breed: "Maltese",
    color: "White",
    age: "4 months",
    size: "small",
    gender: "Female",
    location: "Los Angeles",
    images: [
      { type: 'image', url: "https://source.unsplash.com/800x600/?maltese,dog" },
      { 
        type: 'video', 
        url: "https://example.com/videos/lulu_pampered.mp4",
        thumbnail: "https://example.com/thumbnails/lulu_pampered.jpg"
      },
      { type: 'image', url: "https://source.unsplash.com/800x600/?small-dog" }
    ],
    description: "Fluffy white companion with sweet nature. Enjoys being pampered.",
    adoptionFee: 3400,
    vaccinated: true,
    neutered: false,
    temperament: ["Gentle", "Playful", "Charming"],
    healthNotes: "First vaccinations complete. Needs regular grooming.",
    story: "From responsible breeder - family adoption.",
    goodWith: ["Adults", "Seniors"]
  },
  {
    id: 29,
    name: "Thor",
    breed: "Alaskan Malamute",
    color: "Gray & White",
    age: "3 years",
    size: "large",
    gender: "Male",
    location: "Seattle",
    images: [
      { type: 'image', url: "https://source.unsplash.com/800x600/?malamute,dog" },
      { 
        type: 'video', 
        url: "https://example.com/videos/thor_cold.mp4",
        thumbnail: "https://example.com/thumbnails/thor_cold.jpg"
      },
      { type: 'image', url: "https://source.unsplash.com/800x600/?sled-dog" }
    ],
    description: "Powerful sled dog needing cold climate and space. Very loyal.",
    adoptionFee: 1500,
    vaccinated: true,
    neutered: true,
    temperament: ["Affectionate", "Loyal", "Playful"],
    healthNotes: "Vaccinated and neutered. Heavy seasonal shedder.",
    story: "Owner moved to warm climate unsuitable for breed.",
    goodWith: ["Adults", "Teens"]
  },
  {
    id: 30,
    name: "Willow",
    breed: "Portuguese Water Dog",
    color: "Black",
    age: "2 years",
    size: "medium",
    gender: "Female",
    location: "San Diego",
    images: [
      { type: 'image', url: "https://source.unsplash.com/800x600/?portuguese-water-dog" },
      { 
        type: 'video', 
        url: "https://example.com/videos/willow_water.mp4",
        thumbnail: "https://example.com/thumbnails/willow_water.jpg"
      },
      { type: 'image', url: "https://source.unsplash.com/800x600/?curly-dog" }
    ],
    description: "Hypoallergenic water lover with curly coat. Intelligent and trainable.",
    adoptionFee: 3100,
    vaccinated: true,
    neutered: true,
    temperament: ["Adventurous", "Intelligent", "Athletic"],
    healthNotes: "Vaccinated and spayed. Requires professional grooming.",
    story: "Family had unexpected housing downsizing.",
    goodWith: ["Children", "Other Dogs"]
  }
];

export const getPets = (page = 1, limit = 8, filter = 'all', search = '') => {
  const filtered = petData.filter(pet => 
    (filter === 'all' || pet.size === filter) &&
    (search === '' || 
      pet.name.toLowerCase().includes(search.toLowerCase()) ||
      pet.breed.toLowerCase().includes(search.toLowerCase()) ||
      pet.color.toLowerCase().includes(search.toLowerCase()) ||
      pet.location.toLowerCase().includes(search.toLowerCase()))
  );
  
  const startIndex = (page - 1) * limit;
  return {
    pets: filtered.slice(startIndex, startIndex + limit),
    totalPages: Math.ceil(filtered.length / limit),
    totalPets: filtered.length
  };
};

export const getFeaturedPets = () => {
  return petData.slice(0, 5);
};

export const getPetById = (id: number) => {
  return petData.find(pet => pet.id === id);
};

export default petData;